import {AssetLocation, MapState, MapViewport} from "./model";


export class SetMapMode {
  static readonly type = '[Map] Set Map Mode';

  constructor(
    public mode: MapState,
    public assetId: string,
    public tripId?: string,
    public replayStartTime?: number,
    public replayEndTime?: number,
    public replaySpeed?: number
  ) {
  }
}

export class UpdateViewport {
  static readonly type = '[Map] Update Viewport';

  constructor(public viewport: Partial<MapViewport>) {
  }
}

export class ToggleAutoFollow {
  static readonly type = '[Map] Toggle Auto Follow';

  constructor(public enabled: boolean) {
  }
}

export class ControlReplay {
  static readonly type = '[Map] Control Replay';

  constructor(
    public action: 'play' | 'pause' | 'reset' | 'seek',
    public timestamp?: number
  ) {
  }
}

export class UpdateReplaySpeed {
  static readonly type = '[Map] Update Replay Speed';
  constructor(public speed: number) {
  }
}

export class UpdateAssetLocation {
  static readonly type = '[Map] Update Asset Location';

  constructor(public location: AssetLocation) {
  }
}

export class FetchPathHistory {
  static readonly type = '[Map] Fetch Path History';
}

export class UpdateReplayDate {
  static readonly type = '[Map] Update Replay Date';
  constructor(public date: Date) {
  }
}

export class UpdatePathWithLocation {
  static readonly type = '[Map] Update Path With Location';

  constructor(public location: AssetLocation) {
  }
}

export class FetchStops {
  static readonly type = '[Map] Fetch Stops';
}

export class FetchAreasOfInterest {
  static readonly type = '[Map] Fetch Areas Of Interest';
}

export class AdvanceReplayIndex {
  static readonly type = '[Map] Advance Replay Index';

  constructor(public simulationElapsed: number) {
  }
}

export class CleanupMapResources {
  static readonly type = '[Map] Cleanup Resources';
}
